import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import templateService from '@/services/massMailing/templates/crmTemplateService';

const getTemplateKey = (template, key) => {
    const raw = template?.[key];
    if (raw === null || raw === undefined) return undefined;
    return String(raw);
};

const toEmailTemplateOptions = (rows, { valueKey = 'id' } = {}) =>
    rows.map(template => {
        const value = getTemplateKey(template, valueKey) ?? getTemplateKey(template, 'id');
        return ({
            label: template.name,
            value,
            id: getTemplateKey(template, 'id'),
            crm_template_id: getTemplateKey(template, 'crm_template_id'),
            original: template,
        });
    });

const useEmailTemplateOptions = ({
    defaultPageSize = 20,
    valueKey = 'id',
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await templateService.getAllCrmTemplates({
                    page,
                    pageSize,
                    search,
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);
                const options = toEmailTemplateOptions(rows, { valueKey });

                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch email template.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize, valueKey]
    );

    return loadOptions;
};

export { useEmailTemplateOptions };
